import ReactRailsUJS from "./react_ujs"
import Rails from "@rails/ujs"

if (process.env.NODE_ENV === "development") {
  import("preact/debug")
}

import { runWhenIdle } from "shared/lib/utils"
import { oneTimeSetup, sharedSetup, logCustomDatadogAction, logDatadogError } from "app/scripts/shared_setup"
import { initSentryReact } from "app/scripts/sentry_react_setup"
import { attachNewBadgeForButtons } from "shared/scripts/new_badge_button"
import VanillaFittty from "shared/scripts/vanilla_fittty"
import RubberBandPinchColor from "app/scripts/rubber_band_pinch_color"
import BackButton from "app/scripts/back_button"
import lazyBGImageObserver from "app/scripts/lazy_bg_img_observer"
import toggleHelpWidgetVisibility from "shared/scripts/toggle_help_widget_visibility"
import { GenericSearchInputSetup } from "app/components/universal_search/generic_search_input"
import { UniversalSearchHeader } from "app/components/universal_search/header"

export default function sharedReactSetup() {
  oneTimeSetup()
  initSentryReact()
  GenericSearchInputSetup()
  UniversalSearchHeader()

  document.addEventListener("DOMContentLoaded", () => {
    sharedSetup()
    // Keep VanillaFittty in main path so text sizing doesn't shift line breaks on Applet cards (review feedback)
    VanillaFittty()

    runWhenIdle(() => {
      attachNewBadgeForButtons()
      lazyBGImageObserver()
      if (window.App.user?.id) toggleHelpWidgetVisibility()
    })
  })

  Rails.start()

  window.ReactRailsUJS = ReactRailsUJS
  window.App = window.App || {}
  window.App = Object.assign(window.App, {
    storedFieldPath: (resolveUrl, liveChannelId = "") => {
      if (liveChannelId === "") {
        return `/stored_fields/options?resolve_url=${resolveUrl}`
      } else {
        return `/stored_fields/options?resolve_url=${resolveUrl}&live_channel_id=${liveChannelId}`
      }
    },
  })
  window.App.Comps = {}
  window.App.Scripts = {
    BackButton,
    RubberBandPinchColor,
    VanillaFittty,
  }
  window.App.Utils = {
    logCustomDatadogAction,
    logDatadogError,
  }
}
